import { FC } from 'react';
import {
  classificaDensita,
  DENSITY_RANGES,
  MATCH_REF_DENSITY,
} from '@leopart/calc';
import styles from './DensityScale.module.scss';

/** Fondo scala del righello: l'ultimo range è aperto, si disegna fino a 400. */
const SCALE_MAX = 400;

interface IDensityScaleProps {
  /** m²/giocatore da posizionare sul righello; `null` = solo la scala. */
  value: number | null;
  /** Senza etichette dei range: per gli spazi stretti (preview del form). */
  compact?: boolean;
}

/**
 * Righello della densità di gioco: i quattro range come segmenti colorati
 * (0–100–200–300–400+), la tacca del riferimento gara (~320) e il marcatore
 * del valore corrente. Stesso linguaggio in form (live) e pannello Analisi.
 *
 * I colori dei segmenti sono DATI di @leopart/calc (stessa fonte di barre e
 * badge), non token tema: da qui gli style inline, come per gli accenti
 * categoria delle card.
 */
const DensityScale: FC<IDensityScaleProps> = ({ value, compact = false }) => {
  const clamped = value == null ? null : Math.min(value, SCALE_MAX);
  const range = value == null ? null : classificaDensita(value);

  return (
    <div className={compact ? `${styles.scale} ${styles.compact}` : styles.scale}>
      <div className={styles.track}>
        {DENSITY_RANGES.map((r) => (
          <span
            key={r.id}
            className={styles.segment}
            style={{
              background: r.color,
              width: `${(((r.max ?? SCALE_MAX) - r.min) / SCALE_MAX) * 100}%`,
            }}
          />
        ))}

        {/* Tacca del riferimento gara. */}
        <span
          className={styles.refTick}
          style={{ left: `${(MATCH_REF_DENSITY / SCALE_MAX) * 100}%` }}
        />

        {clamped != null && (
          <span
            className={styles.marker}
            style={{
              left: `${(clamped / SCALE_MAX) * 100}%`,
              borderColor: range?.color,
            }}
          />
        )}
      </div>

      {!compact && (
        <div className={styles.labels}>
          {DENSITY_RANGES.map((r) => (
            <span key={r.id} className={styles.label}>
              {r.labelIt}
            </span>
          ))}
        </div>
      )}
      <span
        className={styles.refLabel}
        style={{ left: `${(MATCH_REF_DENSITY / SCALE_MAX) * 100}%` }}
      >
        gara ~{MATCH_REF_DENSITY}
      </span>
    </div>
  );
};

export default DensityScale;
